module.exports = __webpack_public_path__ + "img/petwelfare.84628b9.png";